import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

export const StatCard = ({ icon: Icon, label, value, change, color = 'purple' }) => {
  const colors = {
    purple: 'from-purple-500 to-indigo-500',
    pink: 'from-pink-500 to-rose-500',
    blue: 'from-blue-500 to-cyan-500',
    green: 'from-emerald-500 to-teal-500',
    orange: 'from-orange-500 to-red-500',
    amber: 'from-amber-500 to-orange-500',
    yellow: 'from-yellow-500 to-amber-500',
    indigo: 'from-indigo-500 to-purple-500',
    emerald: 'from-emerald-500 to-green-500',
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg bg-gradient-to-r ${colors[color] || colors.purple} flex items-center justify-center`}>
          <Icon className="text-white" size={22} />
        </div>
        {change !== undefined && (
          <span className={`flex items-center gap-1 text-xs font-semibold ${change >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
            {change >= 0 ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
            {Math.abs(change)}%
          </span>
        )}
      </div>
      <div className="text-2xl font-bold text-slate-800">{value}</div>
      <div className="text-sm text-slate-500 mt-1">{label}</div>
    </div>
  );
};

export const QuickCard = ({ title, children, className = '' }) => (
  <div className={`bg-white rounded-xl p-6 shadow-sm border border-slate-200 ${className}`}>
    <h3 className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-4">{title}</h3>
    {children}
  </div>
);
